export const sharedIbPermission = { customerData: 1, ibData: 2, operateAmount: 3 }
